import styled, { keyframes } from 'styled-components';

import { media } from '../../utils/mediaQueries';

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(224, 123, 45, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(224, 123, 45, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(224, 123, 45, 0);
  }
`;

export const StepCounter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#1c2b33')};
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
    transition: all 0.2s ease;

    ${media.tabletDown} {
        width: 36px;
        height: 36px;
        font-size: 14px;
    }
`;

export const StepLine = styled.div`
    width: 100%;
    flex: 1;
    height: 1px;
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#1c2b33')};
    margin: 0 24px 0 24px;

    ${media.tabletDown} {
        margin: 0 8px;
    }
`;

export const StepLabel = styled.h3`
    color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#1c2b33')};
    font-weight: 400;
    font-size: 13px;
    margin-left: 8px;
    text-align: center;
    transition: all 0.2s ease;

    ${media.tabletDown} {
        display: none;
    }
`;

export const StepStyled = styled.li.attrs((props) => ({ className: props.className }))`
    display: flex;
    align-items: center;
    flex: 1;
    position: relative;

    &:last-child {
        flex: 0 0 auto;
    }

    &:last-child ${StepLine} {
        display: none;
    }

    /* Active state */
    &.active ${StepCounter} {
        background: ${({ theme }) => (theme.mode === 'dark'
    ? 'linear-gradient(135deg, #4a3728 0%, #5c4530 100%)'
    : 'linear-gradient(135deg, #c0dede 0%, #96c8c8 100%)')};
        color: #1a4d4d;
        box-shadow: 0 0 0 4px ${({ theme }) => (theme.mode === 'dark' ? 'rgba(224, 123, 45, 0.2)' : 'rgba(224, 123, 45, 0.15)')};
        animation: ${pulse} 2s infinite;
    }

    &.active ${StepLabel} {
        color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
        font-weight: 500;
    }

    /* Completed/Visited state */
    &.visited ${StepCounter} {
        background-color: #1a4d4d;
        color: #ffffff;
        border: 2px solid #1a4d4d;
    }

    &.visited ${StepLabel} {
        color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
    }

    &.visited ${StepLine} {
        background-color: #1a4d4d;
    }

    /* Danger state */
    &.danger ${StepCounter} {
        background-color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(239, 68, 68, 0.15)' : '#fee2e2')};
        border: 2px solid #ef4444;
        color: ${({ theme }) => (theme.mode === 'dark' ? '#f87171' : '#ef4444')};
    }

    &.danger ${StepLabel} {
        color: ${({ theme }) => (theme.mode === 'dark' ? '#f87171' : '#ef4444')};
    }
`;

export const StepperContainer = styled.section`
    width: 100%;
    max-width: 70%;
    margin-bottom: 50px;

    ${media.mobile} {
        max-width: 100%;
        margin-bottom: 24px;
    }
`;

export const StepperWrapper = styled.ol`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    list-style: none;

    ${media.mobile} {
        align-items: center;
        justify-content: center;
    }
`;

export const StepWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row!important;
    gap: 0;
`;
